/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rap_Footer_DisclaimerInputs */

const en_rap_footer_disclaimer = /** @type {(inputs: Rap_Footer_DisclaimerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An independent AI tool, not affiliated with any artist or label.`)
};

/**
* | output |
* | --- |
* | "An independent AI tool, not affiliated with any artist or label." |
*
* @param {Rap_Footer_DisclaimerInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const rap_footer_disclaimer = /** @type {((inputs?: Rap_Footer_DisclaimerInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rap_Footer_DisclaimerInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_rap_footer_disclaimer(inputs)
});
export { rap_footer_disclaimer as "rap.footer.disclaimer" }